import { Fragment } from 'react';
import { connect } from 'react-redux';
import { openFilterMenu } from '../actions_creators';
import EducationalTooltip from '../../generic/EducationalTooltip';

const FiltersBtn = ({
  isRecipe,
  recipeFiltersCount,
  skuFiltersCount,
  openFilterMenu,
  isCustomize,
}) => {
  let count = isRecipe ? recipeFiltersCount : skuFiltersCount;

  let preCheckout = parseInt(window.preCheckout) || 0;
  let page = window.location.pathname || '';

  if (preCheckout && page === '/recipes/') {
    count--;
  }

  const FilterBtn = () => {
    return (
      <div
        onClick={openFilterMenu}
        className="filters-btn"
        data-testid="filters-btn"
      >
        {count > 0 ? (
          <Fragment>
            <img
              src={`/public/img/edit_delivery/filter_badge.svg`}
              alt="Filter badge"
            />
            <div className="filters-num-container">
              <div className="filters-num">{count > 0 ? count : null}</div>
            </div>
          </Fragment>
        ) : (
          <img src={`/public/img/edit_delivery/filter.svg`} alt="Filter icon" />
        )}
      </div>
    );
  };

  const renderWithEduToolTip = () => {
    return (
      <EducationalTooltip
        message={`<div>
          <div class="hr-demi hr-mb-8">Filters!</div>
          <div>Click here to try out our new filter feature.</div>
        </div>
        `}
        id="filter-btn-tooltip"
      >
        <FilterBtn />
      </EducationalTooltip>
    );
  };

  return (
    <Fragment>{isCustomize ? renderWithEduToolTip() : <FilterBtn />}</Fragment>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    openFilterMenu: () => dispatch(openFilterMenu()),
  };
};

const getFiltersCount = (filters) => {
  return Object.values(filters).reduce((total, filterCat) => {
    if (Array.isArray(filterCat)) {
      total += filterCat.length;
    } else {
      if (filterCat !== null) {
        total += 1;
      }
    }
    return total;
  }, 0);
};

const mapStateToProps = (state) => {
  return {
    recipeFiltersCount: getFiltersCount(state.filters.appliedRecipeFilters),
    skuFiltersCount: getFiltersCount(state.filters.appliedSkuFilters),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FiltersBtn);
